import script from "./VerifyDocument.vue?vue&type=script&setup=true&lang=js"
export * from "./VerifyDocument.vue?vue&type=script&setup=true&lang=js"

import "./VerifyDocument.vue?vue&type=style&index=0&id=7052b04e&scoped=true&lang=css"

import exportComponent from "/builds/sense/sense-signer/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7052b04e"]])

export default __exports__